module.exports = "https://de18y2hs3hlxs.cloudfront.net/25e9b2d1-8359-4702-9df0-21a378808472/images/notepad-2.png?93936d7ca0aada75a2e9c11d9bd6e63d";